import { useEffect, type ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import BorradoresListado from '@/components/BorradoresListado';
import TramiteSolicitudesListado from '@/components/TramiteSolicitudesListado';
import PageTabs from '@/containers/PageTabs';
import { useGlobalContext } from '@/context/global.context';
import { usePageContext } from '@/context/page.context';
import useRouteTramite from '@/hooks/useRouteTramite';

import { getBreadcrumbTramite } from '@/helpers/navigation';
import type { ITramiteListado } from '@/interfaces/model/don.interface';
import { type ISolicitud } from '@/interfaces/model/solicitudes.interface';


import { ROUTES_LABEL } from '../../constants/routes.constants';

const TAB_ID = {
	solicitudes: 'solicitudes',
	borradores: 'borradores',
};

const TramiteSolicitudesBorradores = (): ReactElement => {
	const navigate = useNavigate();
	const location = useLocation();
	const ROUTES_TRAMITE = useRouteTramite();
	const { appendBreadcrumb, replaceLastBreadcrumb } = usePageContext();
	const { getTramiteData, tramiteSeleccionado } = useGlobalContext();

	const goToDetailOperacion = (rowData: ITramiteListado) => navigate(`${ROUTES_TRAMITE.SOLICITUDES}/${rowData.id}`);
	const goToDetailBorrador = (rowData: ISolicitud) => navigate(`${ROUTES_TRAMITE.BORRADORES}/${rowData.id}`);

	const defaultActiveTab = [ROUTES_TRAMITE.SOLICITUDES, ROUTES_TRAMITE.BORRADORES].some((route) => location.pathname.includes(route))
		? TAB_ID.solicitudes
		: TAB_ID.borradores;

	useEffect(() => {
		const breadcrumbTramite = getBreadcrumbTramite(getTramiteData());
		appendBreadcrumb(ROUTES_LABEL.SOLICITUDES_BORRADORES, [breadcrumbTramite, { label: ROUTES_LABEL.SOLICITUDES_BORRADORES, url: location.pathname }]);
	}, []);

	return (
		<PageTabs
			hasHelp
			title="Solicitudes y borradores"
			actions={[
				{
					mode: 'primary',
					label: 'Nueva solicitud',
					size: 'md',
					onClick() {
						navigate(ROUTES_TRAMITE.BORRADORES_NEW);
					}
				},
			]}
			defaultActive={defaultActiveTab}
			tabs={[
				{
					key: TAB_ID.solicitudes,
					header: 'Solicitudes',
					content: <TramiteSolicitudesListado goToDetail={goToDetailOperacion} idTipoTramite={tramiteSeleccionado} />,
					assignUrl: ROUTES_TRAMITE.SOLICITUDES,
				},
				{
					key: TAB_ID.borradores,
					header: 'Borradores',
					content: <BorradoresListado goToDetail={goToDetailBorrador} idTipoTramite={tramiteSeleccionado} />,
					assignUrl: ROUTES_TRAMITE.BORRADORES,
				},
			]}
			onTabChange={(index) => {
				replaceLastBreadcrumb('Solicitudes y borradores', index === 'solicitudes' ? ROUTES_TRAMITE.SOLICITUDES : ROUTES_TRAMITE.BORRADORES);
			}}
		/>
	);
};

export default TramiteSolicitudesBorradores;
